function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.0545 7.65565C9.0545 6.63422 9.88253 5.80619 10.904 5.80619H15.8744C16.8958 5.80619 17.7239 6.63422 17.7239 7.65565V15.5159C17.7239 16.5373 16.8958 17.3653 15.8744 17.3653H10.904C9.88253 17.3653 9.0545 16.5373 9.0545 15.5159V7.65565Z",
  fill: "#FD7E50"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5895 8.69598C29.6109 8.69598 30.4389 9.52401 30.4389 10.5454V15.5159C30.4389 16.5373 29.6109 17.3653 28.5895 17.3653H20.7292C19.7078 17.3653 18.8798 16.5373 18.8798 15.5159V10.5454C18.8798 9.52401 19.7078 8.69598 20.7292 8.69598L28.5895 8.69598Z",
  fill: "#FD7E50"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8744 18.5213C16.8958 18.5213 17.7239 19.3493 17.7239 20.3707V25.3412C17.7239 26.3626 16.8958 27.1906 15.8744 27.1906H8.01417C6.99274 27.1906 6.16471 26.3626 6.16471 25.3412V20.3707C6.16471 19.3493 6.99274 18.5213 8.01417 18.5213H15.8744Z",
  fill: "#FD7E50"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5491 28.2309C27.5491 29.2524 26.7211 30.0804 25.6997 30.0804H20.7292C19.7078 30.0804 18.8798 29.2524 18.8798 28.2309L18.8798 20.3707C18.8798 19.3493 19.7078 18.5213 20.7292 18.5213H25.6997C26.7211 18.5213 27.5491 19.3493 27.5491 20.3707L27.5491 28.2309Z",
  fill: "#FD7E50"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2185 13.0885C36.2185 14.3652 35.1835 15.4003 33.9067 15.4003C32.6299 15.4003 31.5948 14.3652 31.5948 13.0885C31.5948 11.8117 32.6299 10.7766 33.9067 10.7766C35.1835 10.7766 36.2185 11.8117 36.2185 13.0885Z",
  fill: "#FD7E50"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7588 2.33844C15.7588 3.61523 14.7238 4.65027 13.447 4.65027C12.1702 4.65027 11.1351 3.61523 11.1351 2.33844C11.1351 1.06165 12.1702 0.0266113 13.447 0.0266113C14.7238 0.0266113 15.7588 1.06165 15.7588 2.33844Z",
  fill: "#FD7E50"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5841 33.5482C25.5841 34.8249 24.549 35.86 23.2723 35.86C21.9955 35.86 20.9604 34.8249 20.9604 33.5482C20.9604 32.2714 21.9955 31.2363 23.2723 31.2363C24.549 31.2363 25.5841 32.2714 25.5841 33.5482Z",
  fill: "#FD7E50"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.00879 22.9137C5.00879 24.1905 3.97375 25.2256 2.69696 25.2256C1.42017 25.2256 0.385132 24.1905 0.385132 22.9137C0.385132 21.6369 1.42017 20.6019 2.69696 20.6019C3.97375 20.6019 5.00879 21.6369 5.00879 22.9137Z",
  fill: "#FD7E50"
});

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.225dc59f.svg";
export { ForwardRef as ReactComponent };